import React from "react";

const Popup = ({ visible, onClose, children }) => {
  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40"
        onClick={onClose}
        style={{ display: visible ? "flex" : "none" }}
      />

      {/* Modal */}
      <div
        className="fixed inset-0 flex items-center justify-center z-50"
        aria-modal="true"
        role="dialog"
        onClick={onClose}
        style={{ display: visible ? "flex" : "none" }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-white p-5 lg:p-20 shadow-lg max-w-screen-lg w-[90%] relative"
        >
          {/* Popup Content */}
          {children}
        </div>
      </div>
    </>
  );
};

export default Popup;
